import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sticky"
export default class extends Controller {

  connect() {
    this.observe();
  }

  observe() {
    const observer = new IntersectionObserver(
      ([e]) => { e.target.classList.toggle('sticky--stuck', e.intersectionRatio < 1); },
      { threshold: [1] }
    );

    observer.observe(this.element);
  }
}